import * as DOM from "../../../helpers/dom";
import { BaseSelectBoxDataBind } from "./selectbox-base";

/**
 * Data bind for <select> options. 
 */
export class SelectElementOptionsDataBind extends BaseSelectBoxDataBind
{
    public attributeName = 'data-bind-select-options';
    public selector = '[data-bind-select-options]';
    public eventNames = [];

    protected optionsFromStringArray(strings: string[]): HTMLOptionElement[]
    {
        let result: HTMLOptionElement[] = [];

        for(let s of strings)
        {
           if (s !== null && s !== undefined && s.length > 0)
           {
                result.push(DOM.createElementAs<HTMLOptionElement>('option', {
                    attributes: {
                        value: s,
                    },
                    innerHTML: s
                }));
           }
    
        };

        return result;
    }

    /**
     * Converts multiple types of input values into an array of options for the select element.
     * @param value Value to process into options.
     */
    protected valueToOptions(value: any): HTMLOptionElement[]
    {
        let options: HTMLOptionElement[] = [];
        
        let parsed = this.parseOptions(value);

        return this.optionsFromStringArray(parsed);
    }

    protected replaceOptions(element: HTMLSelectElement, newOptions: HTMLOptionElement[])
    {
        DOM.emptyElement(element);
        
        for(let option of newOptions)
        {
            element.options.add(option);
        }
    }

    protected saveSelection(element: HTMLSelectElement)
    {
        let selectedOptions: string[] = [];
        
        this.iterateOptions(element, (option) =>
        {
            if (option.selected)
            {
                selectedOptions.push(option.value);
            }
        });

        return selectedOptions;
    }

    protected restoreSelection(element: HTMLSelectElement, options: string[])
    {
        for (let selectedValue of options)
        {
            this.iterateOptions(element, option =>
            {
                if (option.value === selectedValue)
                {
                    option.selected = true;
                }
            });
        }
    }

    protected setElementValue(element: HTMLSelectElement, value: any)
    {
        let selection = this.saveSelection(element);
        let options = this.valueToOptions(value);

        this.replaceOptions(element, options);
        this.restoreSelection(element, selection);
    }

    protected getElementValue(element: HTMLSelectElement): any
    {
        let result: string[] = [];
        this.iterateOptions(element, option =>
        {
            result.push(option.getAttribute('value'));
        });

        return result;
    }
}